<div class="service-down-container">
  <div class="container-wrapper">
    <div class="wrapper">
      <div class="img-container">
        <img src="/assets/img/service-down.png" alt="service down" />
      </div>
      <div class="data-container">
        <div class="main">Our service is down</div>
        <div class="sub">No need to worry. We’re resolving some issues, we’ll be back shortly</div>
      </div>
    </div>
    <div class="action-container">
      <button class="btn" (click)="retry()">Come back later</button>
    </div>
  </div>
</div>